/* eslint-disable react/jsx-key */
import { Box, Divider } from '@chakra-ui/react';
import BEIcon from '@molecules/BEIcon';
import { BETabs, BETab, BETabPanel } from '@molecules/BETabs';

const DemoTabs = () => {
  const tablist = [
    <BETab
      id="tab1"
      icon={<BEIcon name="calendar" />}
      dropdown={
        <>
          <BETab
            id="tab1.1"
            icon={<BEIcon name="calendar" />}
            panelId="tabPanel1.1"
          >
            Tab 1.1
          </BETab>
          <BETab
            id="tab1.2"
            icon={<BEIcon name="calendar" />}
            panelId="tabPanel1.2"
          >
            Tab 1.2
          </BETab>
          <BETab
            id="tab1.3"
            icon={<BEIcon name="calendar" />}
            panelId="tabPanel1.3"
          >
            Tab 1.3
          </BETab>
        </>
      }
      panelId="tabPanelDropdown"
    >
      tab dropdown
    </BETab>,
    <BETab id="tab2" icon={<BEIcon name="calendar" />} panelId="tabPanel2">
      Tab 2
    </BETab>,
    <BETab id="tab3" icon={<BEIcon name="calendar" />} panelId="tabPanel3">
      Tab 3
    </BETab>,
    <BETab
      disabled
      id="tab4"
      icon={<BEIcon name="calendar" />}
      panelId="tabPanel2"
    >
      Tab 4
    </BETab>,
    <BETab id="tab5" icon={<BEIcon name="calendar" />} panelId="tabPanel6">
      Tab 5
    </BETab>,
  ];

  return (
    <Box>
      <h2>Tabs</h2>
      <Divider m={2} />
      <BETabs activeTab="tab2" contentId="tabsExample" tablist={tablist}>
        <BETabPanel id="tabPanel1.1" tabId="tab1.1">
          Tab Panel 1.1
        </BETabPanel>
        <BETabPanel id="tabPanel1.2" tabId="tab1.2">
          Tab Panel 1.2
        </BETabPanel>
        <BETabPanel id="tabPanel1.3" tabId="tab1.3">
          Tab Panel 1.3
        </BETabPanel>
        <BETabPanel id="tabPanel2" tabId="tab2">
          Tab Panel 2
        </BETabPanel>
        <BETabPanel id="tabPanel3" tabId="tab3">
          Tab Panel 3
        </BETabPanel>
        <BETabPanel id="tabPanel4" tabId="tab4">
          Tab Panel 4
        </BETabPanel>
        <BETabPanel id="tabPanel5" tabId="tab5">
          Tab Panel 5
        </BETabPanel>
      </BETabs>
    </Box>
  );
};

export default DemoTabs;
